const userMessageType = {
  UPDATE_COUNT_UNREAD_MESSAGE: "UPDATE_COUNT_UNREAD_MESSAGE",
  SET_UPDATE_COUNT_UNREAD_MESSAGE: "SET_UPDATE_COUNT_UNREAD_MESSAGE",
};

export default userMessageType;
